// extracted by mini-css-extract-plugin
module.exports = {"chart":"ProGraph_chart__3q8Nz","graph":"ProGraph_graph__1rltD","toggle":"ProGraph_toggle__GJOyf"};